import React, { FC } from 'react'
import { FacetListChips } from 'components/SA/Facets'
import { BROWSE_NEXT_APP_ROUTE } from '../../helpers/constants'

const BROWSE_FILTERS_WHITE_LIST = [
  'category',
  'styles',
  'subject',
  'mediums',
  'materials',
  'prints_materials',
  'price',
  'prints_price_ranges',
  'size',
  'orientation',
  'color',
  'country',
  'artist_recognition',
  'sort',
  'is_outdoor',
]

type BrowseFiltersChipsProps = {
  selectedCategoryFacet: string
  customClearFilterCallback: () => void
}

const BrowseFiltersChips: FC<BrowseFiltersChipsProps> = ({
  selectedCategoryFacet,
  customClearFilterCallback,
}) => {
  const minSelectedToBeVisible = selectedCategoryFacet !== 'All' ? 2 : 1

  return (
    <FacetListChips
      baseUrl=''
      nextAppRoute={BROWSE_NEXT_APP_ROUTE}
      filtersWhiteList={BROWSE_FILTERS_WHITE_LIST}
      customClearFilterCallback={customClearFilterCallback}
      minSelectedToBeVisible={minSelectedToBeVisible}
    />
  )
}

export default BrowseFiltersChips
